import { render, staticRenderFns } from "./authModal.vue?vue&type=template&id=e5357c38&scoped=true&"
import script from "./authModal.vue?vue&type=script&lang=ts&"
export * from "./authModal.vue?vue&type=script&lang=ts&"
import style0 from "./authModal.vue?vue&type=style&index=0&id=e5357c38&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5357c38",
  null
  
)

export default component.exports